// extracted by mini-css-extract-plugin
module.exports = {"topic":"Result_topic__2oFG-","docset":"Result_docset__2k_1S","description":"Result_description__2P52o","icon":"Result_icon__1kXSW","active":"Result_active__2NR3h"};